// extracted by mini-css-extract-plugin
export default {"large":"spacer_large__OLC6G","small":"spacer_small__XeoYf"};